<template>
  <div>
    <div class="rec-email">
      <div class="header" :class="{anim: anim}"></div>
      <div v-show="!showthanks">
        <p>
          Thank you very much for your rating.
        </p>
        <div class="rec-box">
          <div class="star-flex" v-on:mouseout="handleMouseLeave">
            <star-rating :sel="item <= rating" :hoved="item <= mouseRating" v-for="item in ratings" :key="item" 
              v-on:hover="updateMouseRating"
              v-on:click="updateRating" :rating="item"
              ></star-rating>
          </div>
        </div>
        <div>
          <p>
            Only optionally, any feedback or advice you might kindly have about the service you received, we are all ears.
          </p>
          <div class="rec-advice">
            <textarea v-model="advice" placeholder="Enter your advice here and click send."></textarea>
          </div>
          <div style="margin-bottom:40px">
            <input type="checkbox" v-model="canquote"> 
            May we quote any kind words on the artist's portfolio/website please?
          </div>
        </div>
        <!-- UPDATED 10/18/22 -->
        <div>
          <input type="button" v-on:click="handleSubmit" value="Send" class="ilxnav">
        </div>
      </div>
      <div class="thanks" v-show="showthanks">
        
        <p>
          Thank you very much! Your input helps us all to improve what we do. 
        </p>
        
        <p>
          {{ errmsg }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from '../components/StarRating.vue'
import axios from 'axios'

export default {
  components: {
    StarRating
  },
  props: {
    guid: String,
    irating: String,
    dept: String
  },
  data () {
    return {
      advice: '',
      rating: 0,
      ratings: [1,2,3,4,5],
      mouseRating: 0,
      showthanks: false,
      errmsg: '',
      canquote: true
    }
  },
  computed: {
    anim() {
      return this.dept === 'anim'
    },
    company() {
      if(this.anim) {
        return 'AnimationX'
      }
      return 'IllustrationX'
    }
  },
  created () {
    document.title = 'IllustrationX - Would you recommend us?'
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      if(this.irating) {
        // post the irating, and then ask the question
        this.rating = Number(this.irating)
        const obj = {
          guid: this.guid,
          rating: this.rating,
          advice: '',
          canquote: this.canquote
        }
        console.log('will send', obj)
        try {
          let res = await axios.post(process.env.VUE_APP_JMS_LOC + 'PublicService.aspx/UpdateRecommend', obj)
          console.log(res.data.d)
        }
        catch(err) {
          console.log(err)
        }
      }
    },
    
    updateMouseRating(num) {
      this.mouseRating = num
    },
    updateRating(num) {
      this.rating = num
    },
    async handleSubmit() {
      if((this.rating < 1) || (this.rating > 5)) {
        alert('Please set a star rating first - thanks!')
        return
      }
      
      let res = await axios.post(process.env.VUE_APP_JMS_LOC + 'PublicService.aspx/UpdateRecommend',
        {
          guid: this.guid,
          rating: this.rating,
          advice: this.advice,
          canquote: this.canquote
        }
      )
      console.log('reply', res.data.d)
      if(res.data.d != 'ok'){
        this.errmsg = res.data
      }
      this.showthanks = true
    },
    handleMouseLeave() {
      this.mouseRating = 0
    }
  }
}
</script>

<style>
.rec-box{
  text-align: center;
}
.star-flex{
  border:8px solid #eee;  
  padding:5px 20px;
  display:inline-block;
}

.rec-email{
  text-align:center;
  margin:20px auto;
  width:640px;
}

.rec-email .header{
  background-image:url('../assets/illx-logo-top.png');
  width:100%;
  height:100px;
  background-repeat: no-repeat;
  background-position: center center;
  margin:30px 0;
}

.rec-email .header.anim{
  background-image:url('../assets/main-anim-logo.png');
}

.rec-email textarea{
  width:100%;
  border:1px solid #eee;
  margin:16px;
  padding:16px;
  font-size:16px;
}

p{
  padding:20px 100px;
}

.ilxnav{
  background-color:#a7aba1;
  padding:6px 12px;
  border-radius:5px;
  color:#fff;
  font-size:18px;
  border:none;
  cursor:pointer;
}

.ilxnav:hover{
  background-color:#ce0e2d;
}

</style>